import { combineReducers } from "redux";
import ReducerTest from "../components/Navigation/modules/reducer";
import UserReducer from "../components/Authentication/modules/reducer";
import UsersReducer from "../components/Korisnici/modules/reducer";
import SuppliersReducer from "../components/Dobavljaci/modules/reducer";
import AfipsReducer from "../components/Afip/modules/recuder";
import OffersRefucer from "../components/Ponude/modules/reducer";
import ClientsReducer from "../components/WebKalkulator/modules/reducer";
import DocumentationReducer from "../components/Dokumentacija/modules/reducer";
import ManualReducer from "../components/Dashboard/modules/reducer";
import BrandReducer from "../components/Brendovi/modules/reducer";
import OfferRequestReducer from "../components/OfferRequests/modules/reducer";
import OfferResponseReducer from "../components/OfferResponses/modules/reducer";

export default combineReducers({
  redTest: ReducerTest,
  user: UserReducer,
  usersReducer: UsersReducer,
  suppliersReducer: SuppliersReducer,
  offersReducer: OffersRefucer,
  afipsReducer: AfipsReducer,
  clientsReducer: ClientsReducer,
  documentationReducer: DocumentationReducer,
  manualReducer: ManualReducer,
  brandReducer: BrandReducer,
  offerRequestReducer: OfferRequestReducer,
  offerResponseReducer: OfferResponseReducer,
});
